import { Button, Input, Select, Tag } from "antd";
import FabricCollapase from "./FabricCollapase";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const EditKnitFabric = ({
  productToUpdate,
  genExtra,
  setProductToUpdate,
  setData,
  data,
  options,
  handleChange,
  handleChangeFabric,
  addNewFabric,
}: any) => {
  const { user } = useSelector((state: any) => state.auth);
  return (
    <div>
      {productToUpdate.fabric_types.length === 0 ? (
        <h6 className="text-center p-2 mt-2 text-muted product_doesnt_have">
          This product doesn't have fabric
        </h6>
      ) : (
        productToUpdate.fabric_types.map((ft: any, index: number) => (
          <FabricCollapase
            key={index}
            index={index}
            ft={ft}
            genExtra={genExtra}
            setProductToUpdate={setProductToUpdate}
            productToUpdate={productToUpdate}
            setData={setData}
            data={data}
            options={options}
            handleChangeFabric={handleChangeFabric}
          />
        ))
      )}

      <Button
        type="primary"
        icon={<PlusOutlined style={{ verticalAlign: 0 }} />}
        className="add_new_one"
        disabled={
          !user.permissions.includes("product.fabric.management") &&
          !user.permissions.includes("product.update")
        }
        onClick={addNewFabric}
      >
        Add Another Fabric
      </Button>

      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <th>Composition</th>
            <td>
              <Input
                disabled={
                  !user.permissions.includes("product.fabric.management") &&
                  !user.permissions.includes("product.update")
                }
                type="text"
                placeholder="Composition"
                value={productToUpdate.fabric_composition}
                name="fabric_composition"
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <th>Colours</th>
            <td>
              <Select
                mode="multiple"
                disabled={
                  !user.permissions.includes("product.fabric.management") &&
                  !user.permissions.includes("product.update")
                }
                showArrow
                placeholder="Select Color"
                tagRender={({ label, onClose, closable }: any) => (
                  <Tag
                    color="#00468c"
                    closable={closable}
                    onClose={onClose}
                    style={{ marginRight: 3 }}
                    key={label}
                  >
                    {label}
                  </Tag>
                )}
                defaultValue={
                  productToUpdate.colors &&
                  productToUpdate.colors.map((el: any) => el.name)
                }
                style={{ width: "100%" }}
                onChange={(x: any, value: any) => {
                  setProductToUpdate({
                    ...productToUpdate,
                    colors: value,
                  });
                  setData({
                    ...data,
                    colors: value.map((x: any) => x.id),
                  });
                }}
                options={
                  options.colors_options &&
                  options.colors_options.map((color: any) => {
                    return { ...color, value: color.name };
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EditKnitFabric;
